"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _reactUi = require("@100mslive/react-ui");
var Image = (0, _reactUi.styled)("img", {
  width: "100%",
  height: "auto",
  r: "$3"
});
exports.Image = Image;